// Central permission rules for the kirtan module (deny by default).
// A permission that is 'none' / false means NOT allowed.

// p_create / p_publish are booleans (true/1); p_select/read/update/delete are 'none'|'mine'|'all'.
export const canRead = (p) => !!p && p.p_read !== "none";
export const canCreate = (p) => !!p && !!p.p_create;
export const canUpdate = (p) => !!p && p.p_update !== "none";
export const canDelete = (p) => !!p && p.p_delete !== "none";
export const canPublish = (p) => !!p && !!p.p_publish;

// Route path -> predicate that decides whether the caller may open it.
// (Paths with params like /edit/:id are matched by their static prefix in ProtectedRoute.)
export const ROUTE_ACCESS = {
  "/": canRead, // Kirtan Area (live view / control)
  "/search": canRead, // Search kirtans
  "/manglacharan": canRead, // Manglacharan display
  "/converter": canRead, // Text converter tool
  "/keyboardEdit": canRead, // Keyboard/API config
  "/zoom": canRead, // vMix zoom config
  "/input": canCreate, // Add a new kirtan
  "/edit": canUpdate, // Edit an existing kirtan (/edit/:id)
  "/kirtan-data": (p) => canUpdate(p) || canCreate(p), // DB form (add/edit)
  "/save-form": (p) => canUpdate(p) || canCreate(p), // DB form (save)
};

// Landing page after login = the first page the caller is allowed to open,
// in priority order. Returns null when the user has no access at all.
export const landingPath = (p) => {
  if (canRead(p)) return "/";
  if (canCreate(p)) return "/input";
  if (canUpdate(p)) return "/kirtan-data";
  return null;
};
